export default function DashDepositIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#F2FFF9" />
      <path
        d="M7.25037 22.25H24.7504M8.50037 19.75H23.5004M21.6254 13.5V19.75M17.8754 13.5V19.75M14.1254 13.5V19.75M10.3754 13.5V19.75M7.87533 13.5H24.1253L16.0003 8.5L7.87533 13.5Z"
        stroke="#11A75C"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
